export default {"src":"/_next/static/media/close-icon-black.a8fcfcc5.svg","height":14,"width":14};